module.exports = __webpack_public_path__ + "img/7.479fe5cf.jpg";